<template>
	<goal-settings-content
		widget-type="sub-goal"
		entity-name="membership goal"
		unit="members"
		ignore-subscription-error
		@loading="$emit('loading', $event)"
	/>
</template>

<script>
import GoalSettingsContent from '@/components/Widget/GoalSettingsContent.vue';

export default {
	components: { GoalSettingsContent },
};
</script>
